import React from 'react'
import classNames from 'classnames'

import styles from './UseCasesItem.module.scss'
import { Link } from 'gatsby'
import { ReactComponent as ArrowSVG } from './ArrowSVG.svg'

import { isLocalLink } from '../../../helpers/url'

interface UseCasesItemProps {
  bottomLinkUrl: string
  bottomLinkText: string
  darkMode?: boolean
}

function UseCasesItem({ bottomLinkUrl, bottomLinkText, darkMode }: UseCasesItemProps) {
  return (
    <div className={classNames(styles.root, { [styles.darkRoot]: darkMode })}>
      {isLocalLink(bottomLinkUrl) ? (
        <Link to={bottomLinkUrl} className={styles.bottomLink}>
          <span>{bottomLinkText}</span>
          <ArrowSVG className={styles.arrow} />
        </Link>
      ) : (
        <a href={bottomLinkUrl} className={styles.bottomLink} rel='noreferrer'>
          <span>{bottomLinkText}</span>
          <ArrowSVG className={styles.arrow} />
        </a>
      )}
    </div>
  )
}

export default UseCasesItem
